import styled from '@emotion/styled';

const WayForwardList = styled.ul`
  padding: 0;
  list-style: none;
`;

const WayForwardItem = styled.li`
  display: flex;
  gap: 9px;
  padding: 8px 0;
  border-bottom: 1px solid var(--color-divider-secondary);

  &:last-of-type {
    border-bottom: none;
  }
`;

const WayForwardArrow = styled.div`
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 20px;
  height: 20px;
  margin-top: 3px;
  border-radius: 5px;
  font-size: 10px;
  background: linear-gradient(
    135deg,
    var(--color-i-green),
    var(--color-i-green-focus)
  );
  color: var(--color-i-white);
`;

const WayForwardText = styled.div`
  font-size: 14px;
  line-height: 1.75;
  color: var(--color-text-secondary);
`;

export interface UpscTopicCardWayForwardProps {
  points: string[];
}

const UpscTopicCardWayForward = ({ points }: UpscTopicCardWayForwardProps) => (
  <WayForwardList>
    {points.map((point) => (
      <WayForwardItem key={point}>
        <WayForwardArrow aria-hidden>→</WayForwardArrow>
        <WayForwardText>{point}</WayForwardText>
      </WayForwardItem>
    ))}
  </WayForwardList>
);

export default UpscTopicCardWayForward;
